export default __webpack_public_path__ + "static/media/pricing-yellow.a984e9b8.webp";